module.exports = __webpack_public_path__ + "assets/img/ZT588F-M.0a12f0bf.png";